import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import { formatGivenDate } from '../../../../shared/services/common-functions';

function onGridReady(params) {
    setTimeout(() => {
        params.api.sizeColumnsToFit();
    }, 500);
}

function buildWeekSetter ( buildWk ) {

    const itemBuildWk = formatGivenDate( buildWk, 'YYYY-MM-DD' );

    if ( itemBuildWk === '' ) return ( <span>{itemBuildWk}</span> );
    if ( itemBuildWk === '2000-01-01' ) {

        return 'Inventory';

    } if ( itemBuildWk === '2000-02-01' ) {

        return 'Rework';

    }
    return itemBuildWk;

}

const colDefs = [
    {
        field: 'model',
        headerName: 'Model',
        sortable: false,
        filter: false,
        width: 60,
        colSpan ( params ) {

            return ( params.data.model === '0' ) ? 14 : 1;

        },
        cellRenderer: params => {

            if ( params.value === '' ) return ( <span>{params.value}</span> );
            if ( params.value === '0' ) {

                return ( <span className="totalMessage">{params.data.message}</span> );

            }
            return ( <span>{params.value}</span> );

        }
    },
    {
        field: 'orderNumber',
        headerName: 'Order Number',
        sortable: true,
        filter: true,
        width: 85,
        cellRenderer: params => {

            if ( params.value === '' ) return ( <span>{params.value}</span> );
            return ( <Link to={`/${params.data.unitName}/order/information?ordernum=${params.value}`}>{params.value}</Link> );

        }
    },
    {
        field: 'allocatedIND',
        headerName: 'Allocated Ind',
        sortable: true,
        // filter: true,
        width: 90
    },
    {
        field: 'orderQnty',
        headerName: 'Order Qty',
        sortable: true,
        filter: true,
        width: 70
    }
];

const CheckAttachmentOrdersByBuildWeekTable = props => (

    <section className="atp-search-result-panel check-attachment-orders-by-build-week-panel ">
        <div className="buildWk"> Build Week: {buildWeekSetter( props.buildWeek )} </div>
        <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
            <AgGridReactComponent
                reactNext={true}
                columnDefs={colDefs}
                rowData={props.results}
                onGridReady={onGridReady}
            />
        </div>

    </section>
);

CheckAttachmentOrdersByBuildWeekTable.propTypes = {
    results: PropTypes.array.isRequired,
    buildWeek: PropTypes.number
};
export default CheckAttachmentOrdersByBuildWeekTable;
